<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="form.start_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="form.end_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="end_kilometer" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('end_kilometer')">
                            <b-form-input type="number" v-model="form.end_kilometer"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="deliverer_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('deliverer')">
                            <staff-auto-complete v-model="form.deliverer_id"
                                                 :value-object="delivererValueObject"
                                                 :validate-error="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="receiver_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('recipient')">
                            <staff-auto-complete v-model="form.receiver_id"
                                                 :value-object="receiverValueObject"
                                                 :validate-error="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button @click="update" :disabled="formLoading" variant="primary">
                {{ $t('save') }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete";

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CarReservationService from "@/services/CarReservationService";

    export default {
        props: {
            formId: {
                type: Number
            },
            formData: {
                type: Object,
                default: null
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,

            StaffAutoComplete
        },
        watch: {
            formId: {
                immediate: true,
                handler() {
                    if (this.formData) {
                        this.form = {
                            ...this.form,
                            start_date: this.formData.start_date || null,
                            end_date: this.formData.end_date || null,
                            end_kilometer: this.formData.end_kilometer || null,
                            deliverer_id: this.formData.deliverer_id || null,
                            receiver_id: this.formData.receiver_id || null,
                        };
                        if (this.formData.deliverer_id && this.formData.deliverer) {
                            this.delivererValueObject = {
                                value: this.formData.deliverer_id,
                                text: this.formData.deliverer
                            }
                        }
                        if (this.formData.receiver_id && this.formData.receiver) {
                            this.receiverValueObject = {
                                value: this.formData.receiver_id,
                                text: this.formData.receiver
                            }
                        }
                    }
                }
            },
        },
        data() {
            return {
                formLoading: false,
                form: {
                    deliverer_id: null,
                },
                delivererValueObject: {},
                receiverValueObject: {}

            }
        },
        methods: {
            async update() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    CarReservationService.update(this.formId, this.form)
                                 .then((response) => {
                                     this.$toast.success(this.$t("api." + response.data.message));
                                     this.$emit("updateFormSuccess")
                                 })
                                 .catch((error) => {
                                     this.showErrors(error, this.$refs.formModalValidate)
                                 });
                }
            }
        }
    }
</script>
